import { ref } from 'vue';

import { patchWelcomeGuide } from '@/apis/candidate';
import { JOBS_PATH } from '@/constant/routers/path';
import router from '@/routers';
import { isCandidateApiCodeSuccess } from '@/utils/candidate/isCandidateApiCodeSuccess';
import { extractApiErrorMessage } from '@/utils/extractApiErrorMessage';

export type WelcomeGuideDirectActivationOptions = {
  /** 遷移直前（Bootstrap モーダル解除など） */
  onBeforeNavigate?: () => void | Promise<void>;
};

/**
 * PATCH /v1/candidates/welcome_guide 成功後、企業スカウト求人一覧（welcome ポップアップ付き）へ SPA 遷移する。
 */
export function useWelcomeGuideDirectActivation() {
  const loading = ref(false);
  const errorMessage = ref('');

  async function activateAndGoToDirectJobs(
    options?: WelcomeGuideDirectActivationOptions
  ): Promise<void> {
    loading.value = true;
    errorMessage.value = '';
    try {
      const res = await patchWelcomeGuide();
      if (!isCandidateApiCodeSuccess(res)) {
        errorMessage.value = '企業スカウトの利用開始に失敗しました。';
        return;
      }
      await options?.onBeforeNavigate?.();
      await router.push({
        path: JOBS_PATH,
        query: { direct: 'true', welcome_popup: 'true' },
      });
    } catch (e: unknown) {
      errorMessage.value = extractApiErrorMessage(e);
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    errorMessage,
    activateAndGoToDirectJobs,
  };
}
